import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { connect } from 'react-redux';
import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Button from 'elements/Button';
import Stepper, {
    Controller,
    MainContent,
    Meta,
    Numbering,
} from 'elements/Stepper';
import BookingInformation from 'parts/Checkout/BookingInformation';
import Payment from 'parts/Checkout/Payment';
import Completed from 'parts/Checkout/Completed';
import { submitBooking } from 'store/actions/checkout';

function Checkout(props) {
    const [data, setData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        proofPayment: "",
        bankName: "",
        bankHolder: "",
    });

    const onChange = (event) => {
        setData({
            ...data,
            [event.target.name]: event.target.value,
        });
    };

    const { id: _id } = useParams();

    // Ambil data dari props atau localStorage
    let checkoutData = props.checkout;
    let pageData = props.page;

    try {
        if (!checkoutData || Object.keys(checkoutData).length === 0) {
            checkoutData = JSON.parse(localStorage.getItem("checkoutData"));
        }
        if (!pageData || Object.keys(pageData).length === 0) {
            pageData = JSON.parse(localStorage.getItem("pageData"));
        }
    } catch (err) {
        console.error("Gagal parsing localStorage:", err);
    }

    // Simpan ke localStorage jika dapat dari props
    useEffect(() => {
        if (props.checkout && Object.keys(props.checkout).length !== 0) {
            localStorage.setItem("checkoutData", JSON.stringify(props.checkout));
        }
        if (props.page && Object.keys(props.page).length !== 0) {
            localStorage.setItem("pageData", JSON.stringify(props.page));
        }
        window.scroll(0, 0);
    }, [props.checkout, props.page]);

    const _submit = (nextStep) => {
        const payload = new FormData();
        payload.append("firstName", data.firstName);
        payload.append("lastName", data.lastName);
        payload.append("email", data.email);
        payload.append("phoneNumber", data.phone);
        payload.append("idItem", checkoutData._id);
        payload.append("duration", checkoutData.duration);
        payload.append("bookingStartDate", checkoutData.date.startDate);
        payload.append("bookingEndDate", checkoutData.date.endDate);
        payload.append("accountHolder", data.bankHolder);
        payload.append("bankFrom", data.bankName);
        payload.append("image", data.proofPayment[0]);

        const itemData = pageData[_id].data[0];
        const subTotal = itemData.price * checkoutData.duration;
        const tax = 10;
        const discount = 0;
        const taxAmount = (subTotal * tax) / 100;
        const grandTotal = subTotal + taxAmount - discount;

        payload.append("total", grandTotal);
        payload.append("tax", taxAmount);
        payload.append("discount", discount);
        payload.append("sales", "ONLINE");

        props.submitBooking(payload).then(() => {
            nextStep();
        });
    };

    // Jika data item tidak ditemukan
    if (!pageData || !pageData[_id] || !pageData[_id].data || !pageData[_id].data[0]) return null;
    const itemData = pageData[_id].data[0];

    const isMobile = window.innerWidth <= 767;
    const steps = {
        bookingInformation: {
            title: "Booking Information",
            description: "Please fill up the blank fields below",
            content: (
                <div className="booking-info-content">
                <BookingInformation
                    data={data}
                    checkout={checkoutData}
                    ItemDetails={itemData}
                    onChange={onChange}
                />
                </div>
            ),
        },
        payment: {
            title: "Payment",
            description: "Kindly follow the instructions below",
            content: (
                <Payment
                    data={data}
                    checkout={checkoutData}
                    ItemDetails={itemData}
                    onChange={onChange}
                />
            ),
        },
        completed: {
            title: "Yay! Completed",
            description: null,
            content: <Completed />,
        },
    };

    return (
        <>
            <Header isCentered />

            <div className="container my-4">
                <Stepper steps={steps}>
                    {(prevStep, nextStep, CurrentStep, steps) => (
                        <>
                            {/* Step indicator */}
                            <div className="d-none d-md-block" style={{ marginTop: "80px" }}>
                                <Numbering
                                    data={steps}
                                    current={CurrentStep}
                                    style={{ marginBottom: 50 }}
                                />
                            </div>
                            <div className="d-block d-md-none mt-5">
                                <Numbering data={steps} current={CurrentStep} />
                            </div>
                            <div className="d-block d-md-none text-center mb-3">
                                <h4 className="fw-semibold mb-2">{steps[CurrentStep].title}</h4>
                                <small className="text-muted">{steps[CurrentStep].description}</small>
                            </div>

                            {/* Step content */}
                            <div className="d-none d-md-block">
                            <Meta data={steps} current={CurrentStep} />
                            </div>
                            <MainContent data={steps} current={CurrentStep} />

                            {/* Navigation Buttons */}
                            <div>
                                {CurrentStep === "bookingInformation" && (
                                    <Controller className="text-center text-md-start">
                                        {data.firstName && data.lastName && data.email && data.phone && (
                                            <Fade>
                                                <Button
                                                    className="btn mb-3 w-100 w-md-auto"
                                                    type="button"
                                                    isPrimary
                                                    hasShadow
                                                    onClick={nextStep}
                                                >
                                                    Continue to Book
                                                </Button>
                                            </Fade>
                                        )}
                                        <Button
                                            className="btn w-100 w-md-auto"
                                            type="link"
                                            isLight
                                            href={`/properties/${_id}`}
                                        >
                                            Cancel
                                        </Button>
                                    </Controller>
                                )}

                                {CurrentStep === "payment" && (
                                    <Controller className="text-center text-md-start">
                                        {data.proofPayment && data.bankName && data.bankHolder && (
                                            <Fade>
                                                <Button
                                                    className="btn mb-3 w-100 w-md-auto"
                                                    type="button"
                                                    isPrimary
                                                    hasShadow
                                                    onClick={() => _submit(nextStep)}
                                                >
                                                    Continue to Book
                                                </Button>
                                            </Fade>
                                        )}
                                        <Button
                                            className="btn w-100 w-md-auto"
                                            type="button"
                                            isLight
                                            onClick={prevStep}
                                        >
                                            Cancel
                                        </Button>
                                    </Controller>
                                )}

                                {CurrentStep === "completed" && (
                                    <Controller className="text-center text-md-start">
                                        <Button
                                            className="btn w-100 w-md-auto"
                                            type="link"
                                            isPrimary
                                            hasShadow
                                            href="/"
                                        >
                                            Back to Home
                                        </Button>
                                    </Controller>
                                )}
                            </div>
                        </>
                    )}
                </Stepper>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    checkout: state.checkout,
    page: state.page,
});

export default connect(mapStateToProps, { submitBooking })(Checkout);
